import React, { useState } from "react";
import { IPartner } from "../../services/partnerService";
import { IProject } from "../../services/ttsService";

interface Props {
  project: IProject;
  partners: IPartner[];
  onSave: (partnerId: string | null) => void;
  onCancel: () => void;
}

const AssignPartnerModal: React.FC<Props> = ({ project, partners, onSave, onCancel }) => {
  const currentId = project.partnerId ?? project.publisherId ?? "";
  const [partnerId, setPartnerId] = useState(currentId);

  const activePartners = partners.filter((p) => p.active);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(partnerId || null);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-box modal-box--wide">
        <div className="modal-title">Assign Partner</div>
        <div className="modal-sub">
          Choose a partner for <strong>{project.projectName}</strong>. Only the assigned partner can view and manage this project.
        </div>

        <form onSubmit={handleSubmit}>
          <div className="cp-field">
            <div className="cp-field__label-row">
              <span className="cp-field__label">Partner</span>
            </div>
            <select value={partnerId} onChange={(e) => setPartnerId(e.target.value)}>
              <option value="">Unassigned</option>
              {activePartners.map((p) => (
                <option key={p._id} value={p._id}>
                  {p.name} ({p.email})
                </option>
              ))}
            </select>
          </div>

          <div className="modal-actions">
            <button type="button" className="modal-btn modal-btn--cancel" onClick={onCancel}>
              Cancel
            </button>
            <button type="submit" className="modal-btn modal-btn--save">
              Save Assignment
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AssignPartnerModal;
